export const formatFocusedImage = (
  focalPointImage: any,
  altOverride = false,
) => {
  if (!focalPointImage?.image) return null
  const rawWidth = parseInt(focalPointImage?.image?.file?.details?.image?.width)
  const rawHeight = parseInt(
    focalPointImage?.image?.file?.details?.image?.height,
  )
  const fallbackXValue = isNaN(rawWidth) ? 0 : rawWidth / 2
  const fallbackYValue = isNaN(rawHeight) ? 0 : rawHeight / 2

  const focusedImage = {
    contentfulId:
      focalPointImage?.contentfulId || focalPointImage?.contentful_id,
    wrapperHeight: focalPointImage?.wrapperHeight?.toString(),
    focalPointImage: {
      url: focalPointImage?.image?.file?.url,
      height: focalPointImage?.image?.file?.details?.image?.height || null,
      width: focalPointImage?.image?.file?.details?.image?.width || null,
      x: focalPointImage?.focalPoint?.focalPoint?.x || fallbackXValue,
      y: focalPointImage?.focalPoint?.focalPoint?.y || fallbackYValue,
      title:
        focalPointImage?.image?.title ||
        focalPointImage?.altText ||
        focalPointImage?.title,
      disableImageCompression:
        focalPointImage?.disableImageCompression || false,
    },
    alt: altOverride
      ? altOverride
      : focalPointImage?.altText || focalPointImage?.title || "",
  }
  return focusedImage
}
